import type { AdvisorPlannerInput } from './use-advisor-planner';
import { joinCss } from '@/shared/lib/css-utils';
import { Heading } from '@/shared/ui/heading';
import { AdvisorDndShell } from './advisor-dnd-shell';
import { AdvisorMap } from './advisor-map';
import css from './advisor-planner-workspace.module.scss';
import { FilterBar } from './filter-bar';
import { ItineraryRail } from './itinerary-rail';
import { ProductStack } from './product-stack';
import { useAdvisorPlanner } from './use-advisor-planner';

type AdvisorPlannerWorkspaceProps = AdvisorPlannerInput & {
  title?: string | null;
  layout?: 'console' | 'full';
};

export const AdvisorPlannerWorkspace = ({
  title = 'Advisor planner',
  layout = 'console',
  ...input
}: AdvisorPlannerWorkspaceProps) => {
  const planner = useAdvisorPlanner(input);
  const { Modal: DetailModal, productId, close } = planner.detail;

  return (
    <div className={joinCss(css.root, layout === 'full' && css.rootLayoutFull)}>
      {title ? (
        <Heading as="h1" size="lg">
          {title}
        </Heading>
      ) : null}
      <FilterBar {...planner.filterBar} />
      <AdvisorDndShell dnd={planner.dnd}>
        <div className={css.workspace}>
          <AdvisorMap {...planner.map} key={input.country} />
          <ProductStack {...planner.productStack} />
          <ItineraryRail {...planner.rail} />
        </div>
      </AdvisorDndShell>
      {DetailModal ? (
        <DetailModal onClose={close} productId={productId} />
      ) : null}
    </div>
  );
};
